import React, { useCallback, useContext, useRef, useState } from 'react';
import { bool, number, object, func } from 'prop-types';
import _ from 'lodash';
import ButtonSection from './ButtonSection.js';
import TextMaskCustom from '../../static/TextMaskCustom';
import { validateMail } from '../../../services/Api/User/UserService';
import Notification from '../../common/Notification.jsx';
import { withTranslation } from 'react-i18next';
import {
  GTM_PHYSICAL_CARD_CONFIRMATION_TEXT_CLICK,
  GTM_PHYSICAL_CARD_CONFIRMATION_TEXT_SEND_SUCCESS,
  GTM_PHYSICAL_CARD_CONFIRMATION_EMAIL_CLICK,
  GTM_PHYSICAL_CARD_CONFIRMATION_EMAIL_SEND_SUCCESS,
  GTM_PHYSICAL_CARD_CONFIRMATION_PRINT_CLICK,
  GTM_PHYSICAL_CARD_CONFIRMATION_PRINT_CARD_GENERATED
} from '../../../constants/defaults';
import { AuthContext } from '../../../Contexts';
import {
  newSendCardToMedia,
  printCard
} from '../../../services/Api/Coupon/newCouponService.js';
const invalidChars = ['-', '+', 'e', '.'];
const printJs = typeof window !== 'undefined' ? require('print-js') : undefined;
const RxCardSendCoupon = ({
  classes = {},
  selectedPrice = { PBAClientName: '', PartnerPassword: '' },
  drugData = { Name: '', Form: '', Dosage: '' },
  quantity = 0,
  showNotification = () => {},
  doNotMarket = false,
  isRxCard = false,
  setIsmobileDisplaySent = () => {},
  isFromDiscountPage = false,
  ispharmacySpecificPage = false,
  triggerGTMEvents = () => {},
  closeMobileButtonModal = () => {},
  openModal = () => {},
  buttonLocation,
  isLandingPages,
  isFromPhysicalModal,
  t,
  i18n
}) => {
  const auth = useContext(AuthContext);
  const [showMedia, setShowMedia] = useState('');
  const [inputText, setInputText] = useState('');
  const [requiredInput, setRequiredInput] = useState(false);
  const [validationError, setValidationError] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [activeButton, setActiveButton] = useState(true);
  const [disabledMailBtn, setDisabledMailBtn] = useState(false);
  const [apiLoading, setApiLoading] = useState(false);
  const [displaySent, setDisplaySent] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [apiError, setApiError] = useState(false);

  const inputRef = useRef(null);
  const linkRef = useRef(null);

  const validateEmail = useCallback(email => {
    const re =
      /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
    return re.test(email);
  }, []);

  const toggleShow = useCallback(
    (media = '') => {
      if (showMedia !== media) {
        if (isFromDiscountPage || ispharmacySpecificPage) {
          _.triggerGTMVirtualPageViewEvent({
            event:
              media === 'Email'
                ? 'couponEmailButtonClick'
                : 'couponTextButtonClick',
            buttonLocation: 'prescription-discount-card',
            PharmacyName: selectedPrice.PharmacyName
              ? selectedPrice.PharmacyName
              : 'SingleCare'
          });
        }
        if (isFromPhysicalModal) {
          triggerGTMEvents(
            media === 'Email'
              ? GTM_PHYSICAL_CARD_CONFIRMATION_EMAIL_CLICK
              : GTM_PHYSICAL_CARD_CONFIRMATION_TEXT_CLICK
          );
        }
        setShowButton(
          media === 'Email' &&
            auth?.userData?.isLoggedIn &&
            validateEmail(auth?.userData?.email)
        );
        setShowMedia(media);
        setInputText(
          media === 'Email' && auth?.userData?.isLoggedIn
            ? auth?.userData?.email
            : ''
        );
        setRequiredInput(false);
        setActiveButton(false);
      }
    },
    [
      showMedia,
      isFromDiscountPage,
      ispharmacySpecificPage,
      selectedPrice,
      isFromPhysicalModal,
      triggerGTMEvents,
      auth,
      validateEmail
    ]
  );

  const handleInputChange = useCallback(
    (e = { preventDefault() {}, target: { value: '' } }) => {
      e.preventDefault();
      const { value } = e.target;
      if (showMedia === 'Text' && invalidChars.indexOf(value) !== -1) {
        return;
      }
      if (
        (showMedia === 'Text' &&
          value.length <= 14 &&
          !invalidChars.includes(value)) ||
        showMedia === 'Email'
      ) {
        setShowButton(validateEmail(value));
        setInputText(value);
        setRequiredInput(false);
        setValidationError(false);
      }
    },
    [showMedia, validateEmail]
  );

  const handleInputBlur = useCallback(
    (event = { preventDefault() {}, target: { value: '' } }) => {
      event.preventDefault();
      const { value } = event.target;
      if (linkRef.current && linkRef.current.contains(event?.relatedTarget)) {
        return;
      }
      if (inputText.length === 0) {
        setRequiredInput(true);
        return;
      }
      const validation =
        showMedia === 'Email'
          ? !validateEmail(value)
          : !(inputText.length === 14);
      if (validation) {
        setRequiredInput(true);
        setValidationError(true);
      }
    },
    [showMedia, inputText, validateEmail]
  );

  const handleSubmit = useCallback(
    async (e = { preventDefault() {} }) => {
      e.preventDefault();
      if (showMedia === 'Email' || showMedia === 'Text') {
        let isValidMail = true;
        let textValue = inputText;
        if (textValue.length === 0) {
          return;
        }
        if (showMedia === 'Text') {
          if (inputText.length === 14) {
            setApiLoading(true);
            textValue = inputText.replace(/\D/g, '');
          } else {
            setRequiredInput(true);
            setValidationError(true);
            return;
          }
        } else {
          if (inputText.length <= 0 || !showButton || disabledMailBtn) {
            setRequiredInput(true);
            setValidationError(true);
            return;
          }
          setApiLoading(true);
          const responseData = await validateMail(inputText);
          if (responseData && _.isEqual(responseData.result, 'undeliverable')) {
            setRequiredInput(true);
            setValidationError(true);
            setApiLoading(false);
            isValidMail = false;
            setDisabledMailBtn(false);
          }
          setTimeout(() => setDisabledMailBtn(false), 5000);
        }
        if (isValidMail) {
          const drugName = doNotMarket ? 'Your Prescription' : drugData.Name;
          try {
            let couponData = await newSendCardToMedia(
              selectedPrice.PartnerUser,
              selectedPrice.PartnerPassword,
              drugName,
              selectedPrice.PharmacyName,
              showMedia,
              textValue.trim()
            );
            if (couponData) {
              if (couponData?.data?.result) {
                let result = couponData?.data?.result;
                let finalEventObj = {
                  event:
                    showMedia === 'Email'
                      ? 'couponEmailSendSuccess'
                      : 'couponTextSendSuccess',
                  formId: showMedia === 'Email' ? 'email' : 'text',
                  authNumber: result?.memberNumberFull,
                  grpNumber: result?.groupNumber,
                  bin: result?.bin,
                  pcn: result?.pcn,
                  PharmacyName: selectedPrice.PharmacyName
                    ? selectedPrice.PharmacyName
                    : 'SingleCare'
                };
                if (isFromDiscountPage) {
                  _.triggerGTMVirtualPageViewEvent(finalEventObj);
                }
                let triggerEventObj = {
                  authNumber: result?.memberNumberFull,
                  grpNumber: result?.groupNumber,
                  bin: result?.bin,
                  pcn: result?.pcn
                };
                if (isFromPhysicalModal) {
                  triggerGTMEvents(
                    showMedia === 'Email'
                      ? GTM_PHYSICAL_CARD_CONFIRMATION_EMAIL_SEND_SUCCESS
                      : GTM_PHYSICAL_CARD_CONFIRMATION_TEXT_SEND_SUCCESS,
                    triggerEventObj
                  );
                }
              }
              setIsmobileDisplaySent(true, showMedia);
              setTimeout(() => {
                setIsmobileDisplaySent(false, showMedia);
              }, 5000);
              setApiLoading(false);
              setDisplaySent(true);
              setTimeout(() => {
                setDisplaySent(false);
              }, 4000);
            } else {
              setApiLoading(false);
              setApiError(true);
            }
            showNotification(showMedia, true);
          } catch (err) {
            console.log('Error occured on submit:', err.message);
          }
        }
      }
    },
    [
      showMedia,
      inputText,
      showButton,
      disabledMailBtn,
      selectedPrice,
      drugData,
      quantity,
      doNotMarket,
      isRxCard,
      auth,
      isFromDiscountPage,
      isFromPhysicalModal,
      triggerGTMEvents,
      setIsmobileDisplaySent,
      showNotification
    ]
  );

  const handlePrintPFD = useCallback(
    async (e = { preventDefault() {} }) => {
      e.preventDefault();
      setPdfLoading(true);
      if (isFromPhysicalModal) {
        triggerGTMEvents(GTM_PHYSICAL_CARD_CONFIRMATION_PRINT_CLICK);
      }
      const { PartnerUser, PartnerPassword, PharmacyName } = selectedPrice;
      const couponData = await printCard({
        pid: PartnerUser,
        pPass: PartnerPassword,
        drugName: drugData.Name,
        pharmacyName: PharmacyName,
        showMedia: 'PDF'
      });
      if (!_.isEmpty(couponData?.pdfUrl)) {
        if (isFromPhysicalModal) {
          triggerGTMEvents(
            GTM_PHYSICAL_CARD_CONFIRMATION_PRINT_CARD_GENERATED,
            {
              authNumber: couponData.memberNumberFull,
              grpNumber: couponData.groupNumber,
              bin: couponData.bin,
              pcn: couponData.pcn
            }
          );
        } else {
          _.triggerGTMVirtualPageViewEvent({
            event: 'printCouponGenerated',
            buttonLocation,
            authNumber: couponData?.memberNumberFull,
            grpNumber: couponData?.groupNumber,
            bin: couponData?.bin,
            pcn: couponData?.pcn,
            PharmacyName: PharmacyName ? PharmacyName : 'SingleCare'
          });
        }
        printJs({
          printable: couponData?.pdfUrl,
          type: 'image'
        });
      }
      setShowMedia('');
      setInputText('');
      setRequiredInput(false);
      setActiveButton(true);
      setPdfLoading(false);
    },
    [isFromPhysicalModal, triggerGTMEvents, selectedPrice, buttonLocation]
  );

  const lang = i18n.language;

  return (
    <div className="send-section">
      <ButtonSection
        classes={classes}
        toggleShow={toggleShow}
        printAsPDF={handlePrintPFD}
        activeButton={activeButton}
        showMedia={showMedia}
        pdfLoading={pdfLoading}
        openModal={openModal}
        triggerGTMEvents={triggerGTMEvents}
        closeMobileButtonModal={closeMobileButtonModal}
      />
      {_.isEmpty(showMedia) && isFromDiscountPage && isLandingPages && (
        <p className="cardNote textCenter desktop-only">
          {t(
            'Use the search bar above to look up exact prices for your prescriptions.'
          )}
        </p>
      )}
      {!_.isEmpty(showMedia) && (
        <form className="input-section" onSubmit={handleSubmit}>
          {_.isEqual(showMedia, 'Text') ? (
            <div>
              <div className="input-container">
                <div className={`input-container send-btn-label`}>
                  <label className="input-label">
                    <span className="input-label">{t('Phone Number')}</span>
                    <div className="inputWrapper">
                      <TextMaskCustom
                        id="standard-number"
                        inputRef={ref => (inputRef.current = ref)}
                        value={inputText}
                        onChange={handleInputChange}
                        className={`themeFocus dialogComponent mobileDialog ${
                          requiredInput ? 'errorInput' : 'input-component'
                        }`}
                        onBlur={handleInputBlur}
                        autoComplete="off"
                        placeholder="(212)123-4567"
                        autoFocus
                        aria-invalid={
                          validationError || requiredInput ? 'true' : 'false'
                        }
                        aria-describedby="standard-numbererror"
                        inputMode="numeric"
                      />
                      {requiredInput && (
                        <img
                          className="errorImage"
                          src="/content/images/icons/error.svg"
                          alt=""
                        />
                      )}
                    </div>
                    <span
                      id="standard-numbererror"
                      className={`label-error ${!requiredInput && 'hidden'}`}
                      role="alert"
                    >
                      {`Error: ${
                        validationError
                          ? t('Please enter a valid phone number')
                          : t(
                              'Rx-Card Phone number must be ten digits and include area code.'
                            )
                      }`}
                    </span>
                  </label>
                  <div className="button-section" aria-live="polite">
                    {!apiLoading ? (
                      displaySent ? (
                        <div className="messageSent">
                          <img
                            src="/content/images/icons/sentIcon.png"
                            alt="sent icon"
                          />
                          <span role="status">{t('Rx-card-Sent')}</span>
                        </div>
                      ) : (
                        <button
                          className={`submit-button text-send themeFocus dialogComponent mobileDialog ${
                            inputText.length === 14 && 'enabled'
                          }`}
                          onClick={handleSubmit}
                          aria-live="polite"
                        >
                          {t('Send')}
                        </button>
                      )
                    ) : (
                      <img
                        src="/content/images/loader/loading.gif"
                        alt="loader"
                        className="sendLoader"
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="terms-container" ref={linkRef}>
                <div className={`${classes.demo} labelText`}>
                  <p className="send-terms">
                    {t('T-and-C text1')}
                    {t('See')}&nbsp;
                    <a
                      href={_.withLocale(lang, '/terms-and-conditions')}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="dialogComponent mobileDialog"
                    >
                      {t('Terms & Conditions Text')}
                    </a>
                    .&nbsp;{t('Text STOP to quit.')}
                    <p className="send-terms-message">
                      &nbsp;{t('Message & data rates may apply.')}
                    </p>
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div className="input-container">
                <div className={`send-btn-label input-container`}>
                  <label className="input-label">
                    <span className="input-label">{t('Email Address')}</span>
                    <div className="inputWrapper">
                      <input
                        id="standard-number"
                        value={inputText}
                        onChange={handleInputChange}
                        className={`themeFocus dialogComponent mobileDialog ${
                          requiredInput ? 'errorInput' : 'input-component'
                        }`}
                        onBlur={handleInputBlur}
                        placeholder="johnsmith@email.com"
                        autoComplete="email"
                        autoFocus
                        aria-invalid={
                          validationError || requiredInput ? 'true' : 'false'
                        }
                        aria-describedby="standard-numbererror"
                      />
                      {requiredInput && (
                        <img
                          className="errorImage"
                          src="/content/images/icons/error.svg"
                          alt=""
                        />
                      )}
                    </div>
                    <span
                      id="standard-numbererror"
                      className={`label-error ${!requiredInput && 'hidden'}`}
                      role="alert"
                    >
                      {`Error: ${
                        validationError
                          ? t('Please enter a valid email address.')
                          : t('RxCard-This value is required.')
                      }`}
                    </span>
                  </label>
                  <div className="button-section" aria-live="polite">
                    {!apiLoading ? (
                      displaySent ? (
                        <div className="messageSent">
                          <img
                            src="/content/images/icons/sentIcon.png"
                            alt="sent icon"
                          />
                          <span role="status">{t('Rx-card-Sent')}</span>
                        </div>
                      ) : (
                        <button
                          className={`submit-button email-send themeFocus dialogComponent mobileDialog ${
                            showButton && 'enabled'
                          }`}
                          onClick={handleSubmit}
                          aria-live="polite"
                        >
                          {t('Send')}
                        </button>
                      )
                    ) : (
                      <img
                        src="/content/images/loader/loading.gif"
                        alt="loader"
                        className="sendLoader"
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="terms-container" ref={linkRef}>
                <div className="labelText">
                  <p className="send-terms">
                    {t('T-and-C email')}&nbsp;
                    <a
                      href={_.withLocale(lang, '/terms-and-conditions')}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="dialogComponent mobileDialog"
                    >
                      {t('Terms & Conditions')}
                    </a>
                    {i18n.language === 'es' ? ' de SingleCare' : ''}.
                  </p>
                </div>
              </div>
            </div>
          )}
        </form>
      )}
      {apiError && (
        <Notification
          show={apiError}
          errorMessage={''}
          hideError={() => {
            setApiError(false);
          }}
        />
      )}
    </div>
  );
};

RxCardSendCoupon.propTypes = {
  classes: object,
  selectedPrice: object,
  drugData: object,
  quantity: number,
  showNotification: func,
  doNotMarket: bool,
  isRxCard: bool,
  setIsmobileDisplaySent: func,
  isFromDiscountPage: bool,
  ispharmacySpecificPage: bool,
  triggerGTMEvents: func,
  openModal: func
};
export default withTranslation()(RxCardSendCoupon);
